"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateAPI = exports.AccountSettingsAPIs = exports.userContentAPIs = exports.AwsAPIs = exports.AssessmentsAPIs = exports.CourseAPIs = exports.HomepageAPIs = void 0;
var homepageApi_1 = require("./homepageApi");
Object.defineProperty(exports, "HomepageAPIs", { enumerable: true, get: function () { return __importDefault(homepageApi_1).default; } });
var coursesApi_1 = require("./coursesApi");
Object.defineProperty(exports, "CourseAPIs", { enumerable: true, get: function () { return __importDefault(coursesApi_1).default; } });
var assessmentsApi_1 = require("./assessmentsApi");
Object.defineProperty(exports, "AssessmentsAPIs", { enumerable: true, get: function () { return __importDefault(assessmentsApi_1).default; } });
var awsApi_1 = require("./awsApi");
Object.defineProperty(exports, "AwsAPIs", { enumerable: true, get: function () { return __importDefault(awsApi_1).default; } });
var userContentApi_1 = require("./userContentApi");
Object.defineProperty(exports, "userContentAPIs", { enumerable: true, get: function () { return __importDefault(userContentApi_1).default; } });
var accountSettingsApi_1 = require("./accountSettingsApi");
Object.defineProperty(exports, "AccountSettingsAPIs", { enumerable: true, get: function () { return __importDefault(accountSettingsApi_1).default; } });
var certificateApi_1 = require("./certificateApi");
Object.defineProperty(exports, "CertificateAPI", { enumerable: true, get: function () { return __importDefault(certificateApi_1).default; } });
